import { GRINDS, type GrindKey, SUB_FREQUENCIES, type SubFrequencyKey } from '@c214/shared';
import { Chip } from '../ui/chip';
import { QuantityStepper } from '../ui/quantity-stepper';

export interface CoffeeChoice {
  productId: number | null;
  label: string;
  price: number;
}

interface Props {
  choices: CoffeeChoice[];
  productId: number | null;
  onProductChange: (productId: number | null) => void;
  frequency: SubFrequencyKey;
  onFrequencyChange: (frequency: SubFrequencyKey) => void;
  qty: number;
  onQtyChange: (qty: number) => void;
  grind: GrindKey;
  onGrindChange: (grind: GrindKey) => void;
}

export function SubscriptionBuilder(props: Props) {
  return (
    <div className="space-y-6">
      <div>
        <p className="mono-label mb-3">01 · ЩО ВІДПРАВЛЯТИ</p>
        <div className="flex flex-wrap gap-2">
          {props.choices.map((choice) => (
            <Chip
              key={choice.productId ?? 'roaster'}
              active={props.productId === choice.productId}
              onClick={() => props.onProductChange(choice.productId)}
            >
              {choice.label}
            </Chip>
          ))}
        </div>
      </div>

      <div>
        <p className="mono-label mb-3">02 · ЯК ЧАСТО</p>
        <div className="flex flex-wrap gap-2">
          {SUB_FREQUENCIES.map((freq) => (
            <Chip
              key={freq.key}
              active={props.frequency === freq.key}
              onClick={() => props.onFrequencyChange(freq.key)}
            >
              {freq.label} (−{Math.round(freq.discount * 100)}%)
            </Chip>
          ))}
        </div>
      </div>

      <div>
        <p className="mono-label mb-3">03 · СКІЛЬКИ ПАЧОК 250 Г</p>
        <QuantityStepper value={props.qty} onChange={props.onQtyChange} min={1} max={6} />
      </div>

      <div>
        <p className="mono-label mb-3">04 · ПОМЕЛ</p>
        <div className="flex flex-wrap gap-2">
          {GRINDS.map((grind) => (
            <Chip
              key={grind.key}
              active={props.grind === grind.key}
              onClick={() => props.onGrindChange(grind.key)}
            >
              {grind.label}
            </Chip>
          ))}
        </div>
      </div>
    </div>
  );
}
